module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNi40Mzc1IiB5PSI2LjQzNzUiIHdpZHRoPSIxNi40ODc1IiBoZWlnaHQ9IjE2LjQ4NzUiIHJ4PSI4LjI0Mzc1IiBzdHJva2U9IiMxQTg1RTQiIHN0cm9rZS13aWR0aD0iMiIvPgo8Y2lyY2xlIGN4PSIxNC41MDAxIiBjeT0iMTQuNSIgcj0iNC43MTI1IiBmaWxsPSIjMUE4NUU0Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/field-icon-active/radio.svg
// module id = cnTG
// module chunks = 46